import is from 'date-fns/esm/locale/is/index.js';
import { Formik } from 'formik';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';
import { TextInputField } from '../bootstrap/TextInputField';
import {Validator} from "../../utils/Validator";

export function ChangeEmailForm({ onSubmit }) {
  const INITIAL_FORM_DATA = {
    keycloakId: '',
    email: ''
  };

  const schema = yup.object().shape({
    keycloakId: yup
      .string()
      .required(<FormattedMessage id='errors.fieldRequiredText' />).test(
            'isKeycloackIDValid',
            <FormattedMessage id='errors.keycloakId' />,
            (value) => Validator.validateKeycloakId(value)
        ),
    email: yup
      .string()
      .required(<FormattedMessage id='errors.fieldRequiredText' />).test(
            'isEmailValid',
            <FormattedMessage id='errors.candidatureForm.email' />,
            (value) => Validator.validateEmail(value)
        )
  });






  return (
    <Formik
      initialValues={INITIAL_FORM_DATA}
      validationSchema={schema}
      validateOnBlur={false}
      validateOnChange={true}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values, setSubmitting);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
          <TextInputField
            name='keycloakId'
            labelId='all.keycloakId'
            value={values.keycloakId}
            handleChange={handleChange}
            isInvalid={touched.keycloakId && errors.keycloakId}
            errorMessage={errors.keycloakId}
          />

          <TextInputField
            name='email'
            labelId='all.email'
            value={values.email}
            handleChange={handleChange}
            isInvalid={touched.email && errors.email}
            errorMessage={errors.email}
          />
          <div className='form-actions'>
            <div className='ml-auto'>
              <Button variant='primary' type='submit' disabled={isSubmitting}>
                <FormattedMessage id='all.submitButtonText' />
              </Button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}
